import { HttpOrderRepository } from './infrastructure/repositories/HttpOrderRepository';
import { HttpPurchasedGalleryRepository } from './infrastructure/repositories/PurchasedGalleryRepository';
import { GetAdminOrderDetailUseCase } from './application/use-cases/GetAdminOrderDetailUseCase';
import { UpdateOrderStatusUseCase } from './application/use-cases/UpdateOrderStatusUseCase';
import { GetOrdersUseCase } from './application/use-cases/GetOrdersUseCase';
import { GetOrderDetailUseCase } from './application/use-cases/GetOrderDetailUseCase';
import { DownloadOrderItemUseCase } from './application/use-cases/DownloadOrderItemUseCase';
import { GetDownloadHistoryUseCase } from './application/use-cases/GetDownloadHistoryUseCase';
import { GetPurchasedGalleryUseCase } from './application/use-cases/GetPurchasedGalleryUseCase';
import { GetPurchasedGalleriesUseCase } from './application/use-cases/GetPurchasedGalleriesUseCase';

const orderRepository = new HttpOrderRepository();
const purchasedGalleryRepository = new HttpPurchasedGalleryRepository();

export const orderUseCases = {
  getOrders: new GetOrdersUseCase(orderRepository),
  getOrderDetail: new GetOrderDetailUseCase(orderRepository),
  downloadItem: new DownloadOrderItemUseCase(orderRepository),
  getDownloadHistory: new GetDownloadHistoryUseCase(orderRepository),
  getPurchasedGallery: new GetPurchasedGalleryUseCase(purchasedGalleryRepository),
  getPurchasedGalleries: new GetPurchasedGalleriesUseCase(orderRepository),
  getAdminDetail: new GetAdminOrderDetailUseCase(orderRepository),
  updateStatus: new UpdateOrderStatusUseCase(orderRepository),
};
